<div *ngIf="noticias">
  <section class="row" [ngClass]="idStart == 0 ? 'first-new' : ''">
    <ng-container *ngFor="let item of noticias; let i = index">
      <article class="noticia normal_new columns-1" [ngClass]="[item?.orientacion_titulo ? 'title-position-' + item?.orientacion_titulo : '', item?.colorFondo ? 'noticia-color' : '']" [ngStyle]="item?.colorFondo && { 'background-color': item?.colorFondo }">
        <ng-container *ngIf="item">
          <a [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">
            <ng-container *ngIf="item?.portada_iframe !== '1'">
              <div class="normal_new_content">
                <header *ngIf="item?.tituloInvisible == '0'">
                  <h2 class="header-article" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                    <ng-container *ngIf="!item?.tituloVideoSecundario">
                      {{ item?.tituloVideo }}
                    </ng-container>
                    <ng-container *ngIf="item?.tituloVideoSecundario">
                      {{ item?.tituloVideoSecundario }}
                    </ng-container>
                  </h2>
                </header>

                <footer class="footer-article" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                  <ng-container *ngIf="!item?.noticias_relacionadas">
                    <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && item?.firma_externa">
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        {{ item?.firma_externa }}
                      </span>
                    </ng-container>

                    <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && !item?.firma_externa">
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        {{ item?.nombre_autor }}
                      </span>
                    </ng-container>

                    <ng-container *ngIf="item?.nombre_agencia || item?.autor_anonimo == 1 || !item?.nombre_autor">
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        {{ autorEmpresa }}
                      </span>
                    </ng-container>

                    <time *ngIf="showFecha" [ngStyle]="item?.colorFondo && { color: item?.colorFecha }">
                      {{ formatDate(item?.fecha) | date: "dd/MM/yyyy" }}
                    </time>
                  </ng-container>

                  <div *ngIf="item?.noticias_relacionadas" class="keen-slider" #sliderRef>
                    <ng-container *ngFor="let relacionada of item?.noticias_relacionadas">
                      <span class="keen-slider__slide canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        <a [routerLink]="['/noticias', relacionada.idVideo, relacionada.titulo_seo | kebabCase]" style="width: auto">
                          {{ relacionada?.titulo }}
                        </a>
                      </span>
                    </ng-container>
                  </div>
                </footer>

                <p class="description-article" [innerHTML]="item?.entradillaVideo" [ngStyle]="item?.colorEntradilla && { color: item?.colorEntradilla }"></p>
              </div>

              <!-- <header *ngIf="item?.tituloInvisible == '0' && idStart === 0 && i === 0">
                <h2 class="header-article" [ngClass]="idStart === 0 && i === 0 ? 'tituloArriba' : ''" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                  <ng-container *ngIf="!item?.tituloVideoSecundario">
                    {{ item?.tituloVideo }}
                  </ng-container>
                  <ng-container *ngIf="item?.tituloVideoSecundario">
                    {{ item?.tituloVideoSecundario }}
                  </ng-container>
                </h2>
              </header> -->

              <div style="position: relative; width: 100%; margin-bottom: 0.5rem">
                <div
                  *ngIf="item?.texto_etiqueta"
                  class="etiqueta"
                  [ngClass]="item?.class_etiqueta"
                  [ngStyle]="{
                    color: item?.color_texto_etiqueta,
                    'background-color': item?.color_fondo_etiqueta,
                  }"
                >
                  <span class="etiquetaTxt">{{ item?.texto_etiqueta }}</span>
                </div>

                <figure class="img-noticia" style="margin: 0">
                  <div class="background-image"></div>
                  <app-skeleton-image [created]="item?.fechaCreacion" [size]="980" [src]="item?.urlGenerica" [lazy]="lcp" [isPriority]="isPriority && i === 0" [aspectRatio]="'97 / 55'" [alt]="item?.tituloVideo" [pixelSrc]="item?.pixelPortadaSrc" [pixelAlt]="item?.pixelPortadaAlt"> </app-skeleton-image>
                </figure>

                <app-animacion-video *ngIf="item?.hasVideo" style="top: 0" class="animacion-video" [videoCargando]="false" [click]="false"> </app-animacion-video>
              </div>

              <div class="normal_new_content_mobile">
                <header *ngIf="item?.tituloInvisible == '0'">
                  <h2 class="header-article" [ngClass]="idStart === 0 && i === 0 ? 'tituloAbajo' : ''" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                    <ng-container *ngIf="!item?.tituloVideoSecundario">
                      {{ item?.tituloVideo }}
                    </ng-container>
                    <ng-container *ngIf="item?.tituloVideoSecundario">
                      {{ item?.tituloVideoSecundario }}
                    </ng-container>
                  </h2>
                </header>

                <p class="description-article" [innerHTML]="item?.entradillaVideo"></p>

                <footer class="footer-article">
                  <ng-container *ngIf="!item?.noticias_relacionadas">
                    <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && item?.firma_externa">
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        {{ item?.firma_externa }}
                      </span>
                    </ng-container>

                    <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && !item?.firma_externa">
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        {{ item?.nombre_autor }}
                      </span>
                    </ng-container>

                    <ng-container *ngIf="item?.nombre_agencia || item?.autor_anonimo == 1 || !item?.nombre_autor">
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        {{ autorEmpresa }}
                      </span>
                    </ng-container>

                    <time>{{ formatDate(item?.fecha) | date: "dd/MM/yyyy" }}</time>
                  </ng-container>

                  <div *ngIf="item?.noticias_relacionadas" class="keen-slider" #sliderMobileRef>
                    <ng-container *ngFor="let relacionada of item?.noticias_relacionadas">
                      <span class="keen-slider__slide canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                        <a [routerLink]="['/noticias', relacionada.idVideo, relacionada.titulo_seo | kebabCase]" style="width: auto">
                          {{ relacionada?.titulo }}
                        </a>
                      </span>
                    </ng-container>
                  </div>
                </footer>
              </div>
            </ng-container>

            <ng-container *ngIf="item?.portada_iframe_url && item?.portada_iframe === '1'">
              <header *ngIf="item?.tituloInvisible == '0'">
                <h2 class="header-article" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                  <ng-container *ngIf="!item?.tituloVideoSecundario">
                    {{ item?.tituloVideo }}
                  </ng-container>
                  <ng-container *ngIf="item?.tituloVideoSecundario">
                    {{ item?.tituloVideoSecundario }}
                  </ng-container>
                </h2>
              </header>
              <iframe [src]="item?.portada_iframe_url | safeResourceUrl" width="100%" height="570"> </iframe>
            </ng-container>
          </a>
        </ng-container>
      </article>
    </ng-container>
  </section>
</div>
